import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { APIS } from "../../../../utils/APIS";
import { GET, POST, PUT, DELETE } from "../../../../utils/Methods";
import { IDS } from "../../../../utils/IDS";

//Moments - Get All
export const GetAllMoments = createAsyncThunk(
  "homepage/moments/get-all",
  async (_, { rejectWithValue }) => {
    try {
      const res = await GET(`${APIS.HomePage.Moments}`);
      return res;
    } catch (error) {
      return rejectWithValue(error.message);
    }
  },
);

export const Slice = createSlice({
  name: "moments",
  initialState: {
    all_moments: [],
  },
  reducers: {},
  extraReducers: (builder) => {
    builder

      .addCase(GetAllMoments.pending, (state) => {
        state.status = IDS.SLICESTATUS.Loading;
      })
      .addCase(GetAllMoments.fulfilled, (state, action) => {
        state.status = IDS.SLICESTATUS.Succeeded;
        state.all_moments = action.payload?.data || [];
      })
      .addCase(GetAllMoments.rejected, (state, action) => {
        state.status = IDS.SLICESTATUS.Failed;
        state.error = action.payload;
      });
  },
});

export const {} = Slice.actions;

export default Slice.reducer;
